import { Directive } from '@angular/core';
import { ElementRef, Input, Renderer2, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UserService } from '../services/user.service';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

/**
 * A directive to validate a date value.
 */
@Directive({
	selector: '[dateValidate]'
})
export class DateValidateDirective implements OnInit, OnChanges {
	@Input() dateValidateValue!: string;
	dateFormat: string = 'MM/dd/yyyy';

	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private userService: UserService
	) {
		this.dateFormat = this.userService.getDateFormat();
	}

	ngOnInit() {
		console.log("DateValidateDirective:", this.dateValidateValue);
		this.applyValidation(this.dateValidateValue);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['dateValidateValue']) {
			const newValue = changes['dateValidateValue'].currentValue;
			console.log("Updated value:", newValue);

			this.applyValidation(newValue);
		}
	}

	private applyValidation(value: string): boolean {
		// Consider empty vals to be valid
		if (!value) return true;

		// Requires the CustomParseFormat plugin for strict parsing
		let date = dayjs(value, this.dateFormat, true);
		return date.isValid();
	}
}
